import type { AllRouteEndpoints } from "../routeTypes";

export const engagementReportDashboardRunDashboard =
  "/engagement/report_dashboard/run_dashboard/:dashboard_type(/:dashboard_id)";

export const reportDashboardRunDashboardCacheKeys: AllRouteEndpoints[] = [
  "/engagement/braze_report_dashboard_run_event/:dashboard_type(/:dashboard_id)",
];
